module.exports = __webpack_public_path__ + "img/usecase4.81697d1.svg";